import { render, staticRenderFns } from "./NewAuctionActionsWrapper.vue?vue&type=template&id=58ab15fd&scoped=true"
import script from "./NewAuctionActionsWrapper.vue?vue&type=script&lang=js"
export * from "./NewAuctionActionsWrapper.vue?vue&type=script&lang=js"
import style0 from "./NewAuctionActionsWrapper.vue?vue&type=style&index=0&id=58ab15fd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ab15fd",
  null
  
)

export default component.exports